/**
 * Main page implementation.
 *
 * @author Dmytro Fedotov <d.fedotov@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageInfo',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    ModalMessage  = require('mag-component-modal'),
    RadioList     = require('mag-component-radio-list'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    Scroll        = require('stb-component-scrollbar'),
    Flicker       = require('spa-component-flicker'),
    Button        = require('stb-component-button'),
    $channelsCountWrapper, $channelsCount;


$channelsCountWrapper = dom.tag(
    'div',
    {className: 'amountContainer'},
    $channelsCount = dom.tag('div', {className: 'amount'}, '0')
);


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();


// modal message: select image form list
page.modalImageSelect = new ModalMessage({
    visible: false,
    title: gettext('images'),
    events: {
        show: function () {
            var focusIndex = 0,
                data       = [],
                index;

            for ( index = 0; index < page.list.length; index++ ) {
                data.push({
                    state: false,
                    title: page.list[index].name,
                    value: page.list[index]
                });
                if ( page.currImg === page.list[index] ) {
                    data[index].state = true;
                    focusIndex = index;
                }
            }
            this.children[0].init({data: data, size: data.length, focusIndex: focusIndex});
            this.focus();
        },
        hide: function () {
            page.panelSet.focus();
        }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 3,
            data: [],
            propagate: true,
            events: {
                'click:item': function ( event ) {
                    page.currImg = event.$item.data.value;
                    page.modalImageSelect.hide();
                    page.middlePanel.reset();
                }
            }
        })
    ]
});
page.add(page.modalImageSelect);


// modal message: show full text
page.modalMore = new ModalMessage({
    visible: false,
    focusable: true,
    title: gettext('information'),
    events: {
        show: function () {
            if ( page.middlePanel.list.$focusItem ) {
                page.modalMore.$text.innerText = page.middlePanel.list.$focusItem.children[0].children[0].innerText;
                page.modalMore.$body.innerHTML = '</br>';
                page.modalMore.$body.innerHTML += page.middlePanel.list.$focusItem.children[0].children[1].innerText;
                page.modalMore.$body.innerHTML += '</br></br>';
            }
            this.focus();
        },
        hide: function () {
            page.panelSet.focus();
        }
    }
});
page.add(page.modalMore);


// middle panel (list)
page.middlePanel = new PanelExtended({
    title: [{value: gettext('software update'), className: 'name'}, $channelsCountWrapper],
    main: true,
    children: [],
    className: 'middlePanel'
});

page.middlePanel.scroll = new Scroll({});

page.middlePanel.add(page.middlePanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    size: 6,
    className: 'padded',
    scroll: page.middlePanel.scroll,
    events: {
        overflow: function () {
            page.middlePanel.list.$focusItem.classList.remove('focus');
            page.middlePanel.scroll.hide();
            page.middlePanel.button.focus();
        },
        keydown: function ( event ) {
            LayoutList.prototype.defaultEvents.keydown.call(this, event);
        }
    },
    data: [],
    noData: dom.tag(
        'div',
        {className: 'panelHint'},
        dom.tag(
            'div',
            {className: 'hint'},
            dom.tag('div', {className: 'hint', innerHTML: gettext('No data')})
        )
    )
}), page.middlePanel.scroll);

page.middlePanel.reset = function () {
    var data = [
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Current version:')},
                    {className: 'item text', value: app.updater.current.version}
                ]
            }, {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Description:')},
                    {className: 'item text', value: app.updater.current.description}
                ],
                className: 'theme-item-more',
                click: function () {
                    page.panelSet.blur();
                    page.modalMore.show();
                }
            }, {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Date:')},
                    {className: 'item text', value: app.updater.current.date.toString()}
                ],
                className: 'theme-item-more',
                click: function () {
                    page.panelSet.blur();
                    page.modalMore.show();
                }
            }
        ],
        list = page.middlePanel.list;

    if ( page.currImg ) {
        data = data.concat([
            {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('New version:')},
                    {className: 'item text', value: page.currImg.name}
                ],
                className: (page.list.length > 1 ? 'theme-item-more' : '') + ' theme-separator-top',
                click: function () {
                    if ( page.list.length > 1 ) {
                        page.panelSet.blur();
                        page.modalImageSelect.show();
                    }
                }
            }, {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Description:')},
                    {className: 'item text', value: page.currImg.descr}
                ],
                className: 'theme-item-more',
                click: function () {
                    page.panelSet.blur();
                    page.modalMore.show();
                }
            }, {
                items: [
                    {className: 'item name theme-subhead-color', value: gettext('Date:')},
                    {className: 'item text', value: page.currImg.date.toString()}
                ],
                className: 'theme-item-more',
                click: function () {
                    page.panelSet.blur();
                    page.modalMore.show();
                }
            }/*, {
            items: [
                {className: 'item name theme-subhead-color', value: gettext('Change log:')},
                {className: 'item text', value: page.currImg.logs}
            ],
            className: 'theme-item-more',
            click: function () {
                page.panelSet.blur();
                page.modalMore.show();
            }
        }*/]);
    }

    $channelsCount.innerText = data.length;
    list.init({data: data, focusIndex: list.$focusItem && list.$focusItem.index ? list.$focusItem.index : 0});
};


page.middlePanel.add(page.middlePanel.button = new Button({
    value: gettext('UPDATE'),
    className: 'bottom theme-footer',
    $node: page.middlePanel.$node.appendChild(document.createElement('div')),
    events: {
        click: function () {
            if ( page.currImg ) {
                app.route(app.pages.logs, page.currImg);
            } else {
                app.route(app.pages.main);
            }
        },
        keydown: function ( event ) {
            if ( event.code === keys.up ) {
                page.middlePanel.list.focus();
                page.middlePanel.scroll.show();
                // restore taken focus class
                page.middlePanel.list.$focusItem.classList.add('focus');
                page.middlePanel.list.focusIndex(page.middlePanel.list.data.length - 1);
            } else if ( event.code === keys.down ) {
                page.middlePanel.list.focus();
                page.middlePanel.scroll.show();
                // restore taken focus class
                page.middlePanel.list.$focusItem.classList.add('focus');
                page.middlePanel.list.focusIndex(0);
            } else if ( event.code === keys.ok ) {
                if ( page.middlePanel.button.events['click'] ) {
                    page.middlePanel.button.emit('click', {event: event});
                }
            }
        }
    }
}));

// panel set: main
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetInfo'),
    focusIndex: 0,
    panels: [page.middlePanel]
});
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.main);
            break;
    }
});


page.addListener('show', function ( data ) {
    // list of image from auto update server text file
    page.list = app.updater.list;
    // for usb update use list of 1 element (image at usb)
    if ( data && data.data && Array.isArray(data.data) ) {
        page.list = data.data;
    }
    page.currImg = page.list[0];
    if ( page.currImg ) {
        page.middlePanel.button.$text.innerText = gettext('UPDATE');
    } else {
        window.core.notify({title: gettext('Software up to date, no need for update.'), icon: 'info'});
        page.middlePanel.button.$text.innerText = gettext('CLOSE');
    }
    console.log('page.list: ' + JSON.stringify(page.list));
    page.panelSet.show();
    page.panelSet.focus();
    page.middlePanel.reset();
    // give focus to button
    page.middlePanel.list.$focusItem.classList.remove('focus');
    page.middlePanel.scroll.hide();
    page.middlePanel.button.focus();
});


// public
module.exports = page;
